import { Component } from '@angular/core';

@Component({
  selector: 'ui-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent {
}